<template>
  <v-card
    tile
  >
    <v-card-title
      class="grey lighten-4"
    >
      <span
        class="body-1 grey--text text--darken-1"
        v-text="!selected ? 'Selecione o(s) produto(s)' : 'Produto(s) selecionado(s):'"
      />
      <span class="body-1 accent--text ml-1">{{selected | displaySelected}} </span>
    </v-card-title>
    <v-list
      rounded
    >
      <v-list-item-group
        v-model="selected"
        color="primary"
        multiple
      >
        <processing-result-item
          v-for="(item, idx) in results"
          :key="idx"
          :processing="processing"
          :selected="selected"
          :histogram-graph="item['json_lst_hist_graph']"
          :tile-name="item['ab_tile_name']"
          :total-bands="item['int_total_bands']"
          :raster-name="item['ab_raster_name']"
          :stats-min="item['fl_stats_min']"
          :stats-max="item['fl_stats_max']"
          :min="item['fl_min_val']"
          :max="item['fl_max_val']"
        />
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
  import {filter, map, sortBy} from "lodash/collection"
  import {isEmpty, isEqual, eq} from "lodash/lang"
  import {ProcessingsTilesEventBus} from "../../../helpers/mapview/events"
  import {head} from "lodash/array"
  import ProcessingResultItem from "../Common/ProcessingResultItem"
  import {TILE_TYPE_NAMES} from "../../../helpers/mapview/constants"
  import {listHistogramConfigs} from "../../../api/api-tile"

  const _Map = Symbol.for("_Map")
  const _Processing = Symbol.for("_Processing")

  export default {
    name: "ProcessingTimelineItemResults",
    components: {ProcessingResultItem},
    inject: {_Map, _Processing},
    props: {
      processing: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      selected: [],
      results: []
    }),
    filters: {
      displaySelected(value) {
        let displayValue
        if (isEmpty(value))
          displayValue = ""
        else if (eq(value.length, 1))
          displayValue = TILE_TYPE_NAMES[head(value)]
        else
          displayValue = `${TILE_TYPE_NAMES[head(value)]} (+${value.length - 1})`
        if (!displayValue) return ""
        return displayValue
      },
    },
    methods: {
      onChange(args) {
        const {processing, tileNames} = args
        if (isEqual(this.processing["id_processing"], processing["id_processing"])) {
          this.selected = tileNames
        }
      },
      async onCreated() {
        await listHistogramConfigs(this.$apiAuth.getAuthToken(), this.processing["id_processing"])
          .then(res => {
            const results = res.data.data
            if (!isEmpty(results)) {
              // Ordering the histogram graph
              for (let data of results) {
                if (!data["json_lst_hist_graph"]) continue
                data["json_lst_hist_graph"] = sortBy(data["json_lst_hist_graph"], (a) => {
                  return a["pixel_value"]
                })
              }
              this.results = results
              this.selected = map(
                filter(this.Map.sideBySide.idleLayers,
                  item => isEqual(item["processing"]["id_processing"], this.processing["id_processing"])
                ),
                item => item["tileName"]
              )
            }
          })
      },
    },
    computed: {
      Map() {
        return this._Map()
      },
      Processing() {
        return this._Processing()
      },
    },
    mounted() {
      this.onCreated().then(() => {
        ProcessingsTilesEventBus.$on("change", this.onChange)
      })
    },
    watch: {
      selected(newValue, oldValue) {
        ProcessingsTilesEventBus.$emit("change", {
          processing: this.processing,
          tileNames: newValue
        })
        if (newValue.length > oldValue.length) {
          const diffArr = newValue.filter(x => !oldValue.includes(x))
          ProcessingsTilesEventBus.$emit("add", {
            processing: this.processing,
            tileName: diffArr[0]
          })
        } else {
          const diffArr = oldValue.filter(x => !newValue.includes(x))
          ProcessingsTilesEventBus.$emit("remove", {
            processing: this.processing,
            tileName: diffArr[0]
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">

  .v-list {
    border-radius: 0 !important;
  }

</style>
